var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_vm._v(" 您无法访问此页面 "),_c('q-btn',{attrs:{"label":"登出"},on:{"click":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }